import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['cohorts'], ({ cohorts }) => cohorts.audit, 'cohort');
